import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAddDeliveryMutation } from "store/services/deliveryApi";
import DeliveryFormDriver from "./DeliveryComponents/DeliveryFormDriver";

const DeliveryCreateScreenForDriver = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [addDelivery, { isLoading }] = useAddDeliveryMutation();

  const handleCreateDelivery = async (data) => {
    try {
      const { _id } = await addDelivery(data).unwrap();
      toast.success("Delivery successfully created!");
      navigate(`/app/driver/delivery/${_id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create delivery!"
      );
    }
  };

  // Log the props being passed to DeliveryFormDriver

  return (
    <BreadcrumbLayout 
      breadcrumbs={[
        { title: "Pending Delivery", path: "/app/driver/pendingDelivery" },
        { title: "Create Delivery" }
      ]} 
      isBusy={isLoading}
    >
      <BreadcrumbLayout.Paper>
        <DeliveryFormDriver 
          isBusy={isLoading} 
          onSubmit={handleCreateDelivery}
          initialState={state}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DeliveryCreateScreenForDriver;